import { AdjustmentNote } from '../../../proto/generated/inv_non_serialized_inventory_message_pb';

export class NonSerializedAdjustmentNoteModel {
  name: string;
  direction: number;
  quantity: number;
  unitType: string;
  reason: string;
  notes: string;

  static MapperList(source: AdjustmentNote[]): NonSerializedAdjustmentNoteModel[] {
    const list: NonSerializedAdjustmentNoteModel[] = [];
    source?.forEach((element) => {
      list.push(NonSerializedAdjustmentNoteModel.Mapper(element));
    });
    return list;
  }

  static Mapper(source: AdjustmentNote): NonSerializedAdjustmentNoteModel {
    const destination = new NonSerializedAdjustmentNoteModel();

    if (source != null) {
      // destination.name = source.getName();
      destination.direction = source.getDirection();
      destination.quantity = source.getQuantity();
      // destination.unitType = source.getUnitType();
      destination.reason = source.getReason();
      destination.notes = source.getNotes();
    }

    return destination;
  }

  static MapperProto(source: NonSerializedAdjustmentNoteModel): AdjustmentNote {
    const destination = new AdjustmentNote();

    if (source != null) {
      destination.setName(source.name);
      destination.setDirection(source.direction);
      destination.setQuantity(source.quantity);
      destination.setUnitType(source.unitType);
      destination.setReason(source.reason);
      destination.setNotes(source.notes);
    }

    return destination;
  }
}
